<ng-container>
  <span *ngIf="newServiceIcons ? true : getIconPath(serviceIconsValue)">
    <img [class]="{ 'img-border': isDatatable, 'img-border-active-route': isActiveRouteMap }"
      [src]="newServiceIcons ? SERVICE_ICONS[ServiceProductKey] : getIconPath(serviceIconsValue)"
      [alt]="newServiceIcons ? ServiceProductKey : getAltText(serviceIconsValue)" [title]="
        newServiceIcons ? ('PRODUCT_KEY_NAME.' + ServiceProductKey | translate) : getAltText(serviceIconsValue)
      " />
  </span>
</ng-container>